import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../../../app.config';
import { Observable } from 'rxjs';
import { HistoryResponse } from './history.model';
import { urlJoin } from '../../../../core/helpers/url.helper';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private readonly httpClient = inject(HttpClient);
  private readonly appConfig = inject(AppConfig);

  private readonly url = urlJoin(this.appConfig.url, 'contract');

  fetchHistoryContractByNumAuto(numAuto: string): Observable<HistoryResponse[]> {
    return this.httpClient.get<HistoryResponse[]>(urlJoin(this.url, numAuto, 'history'));
  }
}
